import { formatDate } from '@/utils/formatDate'
import CardOne from '../common/card/CardOne'
import { Bell } from 'lucide-react'

interface INoticeListItemProps {
  type: string
  title: string
  date: string
  isRead: boolean
  handleNoticeClick: (noticeId: string) => void
  id: string
}

const NoticeListItem = ({ type, title, date, isRead, handleNoticeClick, id }: INoticeListItemProps) => {
  return (
    <div onClick={() => handleNoticeClick(id)}>
      <CardOne>
        <div className='flex items-center justify-between mb-2'>
          <div className='flex items-center gap-2'>
            <Bell className='w-5 h-5 text-amber-600' />
            <span className='text-sm font-medium text-gray-600'>
              [{type}] {formatDate(date)}
            </span>
          </div>
          {!isRead && <div className='w-3 h-3 bg-red-500 rounded-full'></div>}
        </div>

        <div>
          <h4 className='text-sm font-medium text-gray-700 leading-relaxed'>{title}</h4>
        </div>
      </CardOne>
    </div>
  )
}

export default NoticeListItem
